import type { VerifyEmailStepProps } from '../types';
import { ResendButton, BackToLoginLink, InfoBox } from '../shared';

/**
 * 验证邮箱步骤页面
 */
export function VerifyEmailStep({
  email,
  resendCountdown = 0,
  loading = false,
  onResendClick,
  onStepChange,
}: VerifyEmailStepProps) {
  /**
   * 格式化倒计时显示
   */
  const formatCountdown = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  return (
    <div className="flex w-full flex-col gap-[28px]">
      {/* 标题区域 */}
      <div className="flex flex-col gap-[12px] items-start">
        <div className="flex items-center gap-[8px]">
          <h2 className="text-[30px] font-semibold leading-none tracking-[-0.3px] text-[#09090b]">Verify your email</h2>
        </div>
      </div>

      {/* 邮箱信息和提示 */}
      <div className="flex flex-col gap-[8px]">
        <p className="text-[14px] font-normal leading-[1.5] tracking-[0.07px] text-[#525252]">
          Verify your email address: <span className="font-medium text-[#171717]">{email}</span>
        </p>

        <InfoBox>
          <p>An email verification link has been sent to your inbox. Please click the link to verify your email.</p>
          <p>If you don't see it in inbox, please check spam folder.</p>
        </InfoBox>
      </div>

      {/* 重发按钮和返回链接 */}
      <div className="flex flex-col items-center gap-[16px]">
        <ResendButton
          countdown={resendCountdown}
          formattedTime={formatCountdown(resendCountdown)}
          onClick={onResendClick}
          loading={loading}
        />

        <BackToLoginLink onClick={() => onStepChange?.('login')} />
      </div>
    </div>
  );
}

export default VerifyEmailStep;
